import { useRef } from "react";
import { Printer } from "react-feather";
import { useReactToPrint } from "react-to-print";
import { Card, CardHeader } from "reactstrap";
import CreatedByMe from "./CreatedByMe";
import { CreatedByMeTitle, Href, Print } from "../../../../constants";
import { Link } from "react-router-dom";

// This component displays a list of tasks created by the user with a print option.
const ListOfTask = () => {
  const contentRef = useRef<HTMLDivElement | null>(null); // Create a reference to store the content that will be printed
  const handlePrint = useReactToPrint({ contentRef }); // Function to handle printing, utilizing the useReactToPrint hook

  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <h4 className="mb-0">{CreatedByMeTitle}</h4>
        <Link to={Href} onClick={()=>handlePrint()}>
          <Printer className="me-2" />
          {Print}
        </Link>
      </CardHeader>
      <CreatedByMe ref={contentRef} />
    </Card>
  );
};

export default ListOfTask;
